// eslint-disable-next-line import/no-extraneous-dependencies
import $ from 'jquery';
import Chart from 'chart.js/auto';

$(() => {
  // 現在地取得成功時のみサーバに処理を送信する
  function successGetPosition(position) {
    const url = $('#sort_distance').attr('href');
    $('#sort_distance').attr('href', `${url}&lat=${position.coords.latitude}&lng=${position.coords.longitude}`);
    window.location.href = `${url}&lat=${position.coords.latitude}&lng=${position.coords.longitude}`;
  }

  function failGetPosition(error) {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        alert('位置情報の取得が許可されませんでした');
        break;
      case error.POSITION_UNAVAILABLE:
        alert('電波状況などで位置情報が取得できませんでした');
        break;
      case error.TIMEOUT:
        alert('位置情報の取得にてタイムアウトが発生しました');
        break;
      case error.UNKNOWN_ERROR:
        alert('原因不明のエラーが発生しました');
        break;
    }
  }

  // 現在地に近いボタン押下時、現在地を取得する
  if ($('#sort_distance').length) {
    $('#sort_distance').click(function f() {
      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      };

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(successGetPosition, failGetPosition, options);
      } else {
        alert('ご使用中のブラウザは現在地検索に対応されておりません');
      }
      return false;
    });
  }

  // 美肌ポイントのレーダーチャート
  if ($('#skin_point').length) {
    const ctx = document.getElementById('skin_point');
    // 構成、オプションの設定は公式サイトの以下を参照
    // https://www.chartjs.org/docs/latest/charts/radar.html
    const config = {
      type: 'radar',
      data: {
        labels: ['スベスベ', 'デトックス', 'しっとり', 'リラックス'],
        datasets: [
          {
            label: '美肌ポイント',
            data: [
              Number(ctx.dataset.silkiness),
              Number(ctx.dataset.detox),
              Number(ctx.dataset.moistness),
              Number(ctx.dataset.relaxation),
            ],
            backgroundColor: ['rgba(156, 226, 216, 0.8)'],
          },
        ],
      },
      options: {
        elements: {
          line: {
            borderWidth: 0,
          },
        },
        responsive: true,
        scales: {
          r: {
            max: 5, //グラフの最大値
            min: 0, //グラフの最小値
            ticks: {
              stepSize: 1, //目盛間隔
            },
          },
        },
        maintainAspectRatio: false,
      },
    };
    new Chart(ctx, config);
  }

  // pieグラフ
  //
  // [方針]
  // - pieグラフはchart.jsで処理
  // - pieグラフの個々の要素を示すラベルはSpotPieLabelCreatorで処理

  // 色は共通で利用
  const spotPieChartColors = [
    'rgb(102, 157, 221)',
    'rgb(171, 113, 171)',
    'rgb(227, 139, 163)',
    'rgb(226, 102, 102)',
    'rgb(224, 160, 119)',
    'rgb(255, 243, 102)',
    'rgb(165, 219, 214)',
    'rgb(119, 208, 174)',
    'rgb(210, 237, 234)',
    'rgb(232, 246, 244)',
    'rgb(255, 255, 255)',
    'rgb(255, 235, 0)',
    'rgb(230, 230, 230)',
    'rgb(206, 252, 52)',
  ];

  // ラベル生成用
  class SpotPieLabelsCreator {
    constructor({ colors, labelTexts, wrapperEl }) {
      if (!colors || !labelTexts || !wrapperEl) return;
      if (labelTexts.length > colors.length) return;

      this.colors = colors;
      this.labelTexts = labelTexts;
      this.wrapperEl = wrapperEl;

      this.render();
    }

    render() {
      for (let i = 0; i < this.labelTexts.length; i++) {
        const labelEl = document.createElement('div');
        const labelColorEl = document.createElement('span');
        const labelTextEl = document.createElement('span');

        labelEl.classList.add('spot-pie-labels__item');
        labelColorEl.classList.add('spot-pie-labels__item-mark');
        labelTextEl.classList.add('spot-pie-labels__item-text');

        labelColorEl.style.backgroundColor = this.colors[i];
        labelTextEl.textContent = this.labelTexts[i];

        labelEl.append(labelColorEl);
        labelEl.append(labelTextEl);
        this.wrapperEl.append(labelEl);
      }
    }
  }

  if ($('#component_cation').length) {
    // 陽イオンの円グラフの生成
    const ctx = document.getElementById('component_cation');
    // 構成、オプションの設定は公式サイトの以下を参照
    // https://www.chartjs.org/docs/latest/charts/doughnut.html#pie
    const config = {
      type: 'pie',
      data: {
        // labels: ctx.dataset.labels.split(','),
        datasets: [
          {
            data: ctx.dataset.data.split(','),
            // 円グラフの背景色を変更するオプション設定
            backgroundColor: spotPieChartColors,
            hoverOffset: 4,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
      },
    };
    new Chart(ctx, config);

    // 陽イオンのラベルの生成
    new SpotPieLabelsCreator({
      colors: spotPieChartColors,
      labelTexts: document.getElementById('component_cation').dataset.labels.split(','),
      wrapperEl: document.getElementById('cation_labels'),
    });
  }

  if ($('#component_anion').length) {
    // 陰イオンの円グラフの生成
    const ctx = document.getElementById('component_anion');
    // 構成、オプションの設定は公式サイトの以下を参照
    // https://www.chartjs.org/docs/latest/charts/doughnut.html#pie
    const config = {
      type: 'pie',
      data: {
        // labels: ctx.dataset.labels.split(','),
        datasets: [
          {
            data: ctx.dataset.data.split(','),
            // 円グラフの背景色を変更するオプション設定
            backgroundColor: spotPieChartColors,
            hoverOffset: 4,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
      },
    };
    new Chart(ctx, config);

    // 陰イオンのラベルの生成
    new SpotPieLabelsCreator({
      colors: spotPieChartColors,
      labelTexts: document.getElementById('component_anion').dataset.labels.split(','),
      wrapperEl: document.getElementById('component_labels'),
    });
  }
});
